var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "top-ui" }, [
    _c("div", { staticClass: "top-ui-header" }, [
      _c("h1", { staticClass: "logo" }),
      _c("ul", { staticClass: "top-ui-util" }, [
        _c("li", { staticClass: "talk" }, [
          _c("p", { staticClass: "dot" }),
          _vm._v(" " + _vm._s(this.$t("mirroring.consulting")) + " "),
        ]),
        _vm.timer
          ? _c("li", { staticClass: "timmer" }, [_vm._v(_vm._s(_vm.timer))])
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "top-ui-btn-area" }, [
      _c("ul", { staticClass: "top-ui-btn" }, [
        _c("li", { staticClass: "draw-btn-li" }, [
          _c("button", {
            staticClass: "draw-btn pointer",
            class: { enabled: _vm.$parent.toolkit === "LaserPointer" },
            on: {
              click: function ($event) {
                return _vm.onClickPalette($event, { toolkit: "LaserPointer" })
              },
            },
          }),
        ]),
        _c("li", { staticClass: "draw-btn-li" }, [
          _c("button", {
            staticClass: "draw-btn pen",
            class: { enabled: _vm.$parent.toolkit === "Pencil" },
            on: {
              click: function ($event) {
                return _vm.onClickPalette($event, { toolkit: "Pencil" })
              },
            },
          }),
        ]),
        _c("li", { staticClass: "draw-btn-li" }, [
          _c("button", {
            staticClass: "draw-btn highlighter",
            class: { enabled: _vm.$parent.toolkit === "Highlighter" },
            on: {
              click: function ($event) {
                return _vm.onClickPalette($event, { toolkit: "Highlighter" })
              },
            },
          }),
        ]),
        _c("li", { staticClass: "draw-btn-li" }, [
          _c("button", {
            staticClass: "draw-btn eraser",
            class: { enabled: _vm.$parent.toolkit === "Eraser" },
            on: {
              click: function ($event) {
                return _vm.onClickPalette($event, { toolkit: "Eraser" })
              },
            },
          }),
        ]),
      ]),
      _c("div", {}, [
        _c("button", { staticClass: "exit-btn" }, [
          _vm._v(_vm._s(this.$t("mirroring.stop"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }